site.smalldropmenu = {
	$menu: $('.nav-search .menu', '#main'),

	init: function () {
		$('.level1.children', site.smalldropmenu.menu).click(function (e) {
			e.preventDefault();
			e.stopPropagation();

			if ($(this).hasClass('open')) {
				site.smalldropmenu.closeAll();
			} else {
				site.smalldropmenu.closeAll();
				$(this).addClass('open');
			}
		});

		$('.nav-search .mmLevel2').on('click', function(e) {
			e.stopPropagation();
		});

		$('body').click(function () {
			site.smalldropmenu.closeAll();
		});
	},

	closeAll: function () {
		$('.level1', site.smalldropmenu.menu).removeClass('open');
	}
};

site.inits.push('site.smalldropmenu.init()');
site.inits.push('site.mMenu.init()');
